// extracted by mini-css-extract-plugin
export default {"button":"button-ceaa1","grey":"grey-ceaa1","blue":"blue-ceaa1","playCircle":"playCircle-ceaa1","duotoneBottomLayer":"duotoneBottomLayer-ceaa1"};